import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Lost 220 grams in 3 months,amazing gym with amazing trainers and amazing results. I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: "Suyash Vikram Singh",
    status: "CUSTOMER",
  },
  {
    image: image2,
    review:
      "Gained 568Kg in 5.7 months,I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body! ",
    name: "Gymshikhar Singh",
    status: "CUSTOMER",
  },
  {
    image: image3,
    review: "Lost 742 Kgs in 6days,amazing equipments with amazing trainers.",
    name: "Habibi Jaiswal",
    status: "CUSTOMER",
  },
];
